import {ProjectActions as Actions} from '../ActionTypes'
import {makeRequest} from '../../core/http'
import requests from '../../core/request'

const createActions = (function () {
    const {REQUEST, SUCCESS, ERROR} = Actions.CREATE
    return {
        request: {type: REQUEST},
        success (id) {
            return {
                type: SUCCESS,
                payload: id
            }
        },
        error (error) {
            return {
                type: ERROR,
                payload: error
            }
        }
    }
}())

const getActions = (function () {
    const {REQUEST, SUCCESS, ERROR} = Actions.GET
    return {
        request: {type: REQUEST},
        success (projects) {
            return {
                type: SUCCESS,
                payload: projects
            }
        },
        error (error) {
            return {
                type: ERROR,
                payload: error
            }
        }
    }
}())

const viewActions = (function () {
    const {REQUEST, SUCCESS, ERROR} = Actions.VIEW
    return {
        request: {type: REQUEST},
        success (projects) {
            return {
                type: SUCCESS,
                payload: projects
            }
        },
        error (error) {
            return {
                type: ERROR,
                payload: error
            }
        }
    }
}())

const editActions = (function () {
    const {REQUEST, SUCCESS, ERROR} = Actions.EDIT
    return {
        request: {type: REQUEST},
        success (project) {
            return {
                type: SUCCESS,
                payload: project
            }
        },
        error (error) {
            return {
                type: ERROR,
                payload: error
            }
        }
    }
}())

export const getProjects = function () {
    return makeRequest(requests.project.get, getActions)
}

export const createProject = function (projectData) {
    return makeRequest(requests.project.create, createActions, projectData)
}

export const getProjectDetails = function (projectId) {
    return makeRequest(requests.project.view(projectId), viewActions)
}

export const editProjectDetails = function (projectId, projectUpdate, onSuccess) {
    return makeRequest(requests.project.edit(projectId), editActions, projectUpdate, onSuccess)
}
